import script from "./rich-text-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./rich-text-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./rich-text-setting-ly.vue?vue&type=style&index=0&id=aace0880&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aace0880"]])

export default __exports__